"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _excluded = ["title", "titleId"];
var SvgBug = function SvgBug(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.738 2.49A.75.75 0 0 0 9 3.25V4c0 .632.2 1.22.538 1.706A3.763 3.763 0 0 0 7.013 9H6.75A2.238 2.238 0 0 1 4.5 6.75v-1.5a.75.75 0 1 0-1.5 0v1.5a3.761 3.761 0 0 0 3.75 3.75H7v1.75H2.75a.75.75 0 1 0 0 1.5H7v1.604c0 .05.005.097.007.146H6.75A3.761 3.761 0 0 0 3 19.25v1.5a.75.75 0 1 0 1.5 0v-1.5c0-1.252.998-2.25 2.25-2.25h.521c.629 1.895 2.305 3.354 4.398 3.49 2.367.152 4.424-1.367 5.098-3.49h.483c1.252 0 2.25.998 2.25 2.25v1.5a.752.752 0 0 0 1.284.537.75.75 0 0 0 .216-.537v-1.5a3.761 3.761 0 0 0-3.75-3.75H17v-1.75h4.25a.751.751 0 1 0 0-1.5H17V10.5h.25A3.761 3.761 0 0 0 21 6.75v-1.5a.75.75 0 1 0-1.5 0v1.5c0 1.252-.998 2.25-2.25 2.25h-.263a3.763 3.763 0 0 0-2.525-3.294A2.976 2.976 0 0 0 15 4v-.75a.751.751 0 1 0-1.5 0V4c0 .837-.663 1.5-1.5 1.5A1.49 1.49 0 0 1 10.5 4v-.75a.75.75 0 0 0-.762-.76ZM10.75 7h2.5c1.252 0 2.25.998 2.25 2.25v.377a.752.752 0 0 0 0 .243v3.007a.752.752 0 0 0 0 .243v2.38a3.486 3.486 0 0 1-3.734 3.492c-1.849-.12-3.266-1.751-3.266-3.638v-2.231a.75.75 0 0 0 0-.243V9.873a.75.75 0 0 0 0-.243v-.38C8.5 7.998 9.498 7 10.75 7Z"
  }));
};
var _default = SvgBug;
exports.default = _default;